import CloudServicesImg from "public/cloud-services/cloud-services.png";
import { ListWithLabel } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Unlock Scalable, Secure, and Future-Ready Cloud Infrastructure with OneMind ",
  description: [
    "Modern enterprises rely on cloud technology to drive agility, scalability, and cost efficiency — all while ensuring robust data protection and operational resilience. OneMind’s Cloud Services empower businesses to seamlessly manage workloads, accelerate innovation, and eliminate the overhead of physical infrastructure.",
    "Choose from:",
  ],
  children: (
    <ListWithLabel
      key="list"
      points={[
        {
          label: "Public Cloud ",
          text: "A cost-effective, scalable solution for businesses looking to leverage the power of the cloud without the need for physical infrastructure.",
        },
        {
          label: "Private Cloud ",
          text: "Enterprise-grade, dedicated infrastructure with enhanced control, compliance, and performance.",
        },
        {
          label: "POC Cloud (Proof of Concept)",
          text: "A flexible, fast-launch environment for testing, validation, and innovation without long-term commitment.",
        },
      ]}
    />
  ),
  conclusion:
    "Whether you're modernizing legacy systems or building cloud-native applications, OneMind delivers the cloud foundation you need — secure, scalable, and aligned with your business goals.",
  image: CloudServicesImg,
  imageHeight: "450px",
};
